import loggerService from './logger.service';

export function getValueFromLocalstore(keyName: string, fallback?: any) {
  try {
    const val = window.localStorage.getItem(keyName);
    return val ? JSON.parse(val) : fallback;
  } catch (err) {
    loggerService.error('Cannot get value from browser localstore!', err);
    return fallback;
  }
}

export function saveValueToLocalstore(keyname: string, value: any) {
  try {
    window.localStorage.setItem(keyname, JSON.stringify(value));
  } catch (err) {
    loggerService.error('Cannot set value in browser localstore!', err);
  }
}

export function getCookieValue(name: string) {
  const value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

  if (value === 'false') {
    return false;
  }

  return value;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function setCookieValue(name: string, value: any) {
  document.cookie = `${name}=${value}; path=/;`;
}

export function onStorageEvent(callback: (e: StorageEvent) => void, ...keys: string[]) {
  function handler(e: StorageEvent) {
    if (keys.includes(e.key || '')) {
      callback(e);
    }
  }
  window.addEventListener('storage', handler);

  return () => window.removeEventListener('storage', handler);
}

export const getValueFromSessionStorage = (key: string, fallback?: any) => {
  try {
    const val = window.sessionStorage.getItem(key);
    return val ? JSON.parse(val) : fallback;
  } catch (err) {
    loggerService.error('Cannot get value from browser sessionstore!', err);
    return fallback;
  }
};

export const saveValueToSessionStorage = (key: string, value: any) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};
